<template>
  <component :is="tbExtensaoData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert
        variant="danger"
        :show="tbExtensaoData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
            class="alert-link"
            :to="{ name: 'apps-tb-extensao-list'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <b-tabs
        v-if="tbExtensaoData"
        pills
    >

      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon
              icon="UserIcon"
              size="16"
              class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Extensao</span>
        </template>
        <TbExtensaoEditInformation
            :extensao-data="tbExtensaoData"
            :extensao-campos="tbExtensaoCamposData"
            class="mt-2 pt-75"
        />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink,
} from 'bootstrap-vue';
import { ref, onUnmounted } from '@vue/composition-api';
import router from '@/router';
import store from '@/store';
import tbExtensaoStoreModule from '../tbExtensaoStoreModule';
import TbExtensaoEditInformation from './TbExtensaoEditInformation.vue';

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    TbExtensaoEditInformation,
  },
  setup() {
    const tbExtensaoData = ref(null);
    const tbExtensaoCamposData = ref(null);

    const USER_APP_STORE_MODULE_NAME = 'app-extensao';

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, tbExtensaoStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    store.dispatch('app-extensao/fetchExtensao', { id: router.currentRoute.params.id })
      .then((response) => {
        console.log(response.data.data);
        tbExtensaoData.value = response.data.data;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          tbExtensaoData.value = undefined;
        }
      });
    store.dispatch('app-extensao/fetchExtensaoCampos', { id: router.currentRoute.params.id })
      .then((response) => {
        console.log(response.data.data);
        tbExtensaoCamposData.value = response.data.data;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          tbExtensaoCamposData.value = undefined;
        }
      });

    return {
      tbExtensaoData,
      tbExtensaoCamposData,
    };
  },
};
</script>

<style>

</style>
